import styles from './FreeTrialSection.module.scss';

import React from 'react';
import { Container } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeUp, FadeLeft } from 'src/components/Animations';
import RetinaImage from 'src/components/RetinaImage';
import ButtonLink from 'src/components/ButtonLink';

import ImgLaptopZoneAndWeight from 'src/images/img-laptop-zone-and-weight.png';
import ImgLaptopZoneAndWeight2x from 'src/images/img-laptop-zone-and-weight@2x.png';

export default (props) => (
  <ScrollOverPack styleName='free-trial-section'>
      <TweenOne key='container' component={Container} {...FadeUp}>
          <div styleName='text-container'>
              <div className='h1 text-blue'>
                  Ready to learn more?
              </div>
              <div className='h2'>
                  Drop us a line, let&rsquo;s talk.
              </div>
              <ButtonLink to='/contact' style={{marginTop: '20px'}}>
                  Schedule a demo
              </ButtonLink>
              <div styleName='note'>
                  Contact our sales team for a live demo and more information. Or
                  try a 7-day risk-free trial (no credit card required).
              </div>
          </div>
      </TweenOne>
      <TweenOne key='splash-image-container'
                styleName='splash-image-container'
                {...FadeLeft}>
          <RetinaImage srcSet={[ImgLaptopZoneAndWeight, ImgLaptopZoneAndWeight2x]} styleName='splash-image' />
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/FreeTrialSection.js